import Vue from 'vue';
import { SButton } from "../../../components/ui-components";
import vacancyAdmin from "../../../components/base/vacancies/vacancy-admin"
import useVacancies from '../../domain/use-vacancies'
import { formatSalary }  from "../../utils/utils"
import IconReload from '../../../components/icons/icon-reload'
import PreloaderNew from '../../../components/preloader/preloader-new'

export default Vue.component('vacanciesListAdmin', {
  components: {
    SButton,
    vacancyAdmin,
    IconReload,
    PreloaderNew
  },

  data() {
    return {
      loading: false,
      vacanciesListAdmin: [],
      vacanciesMeta: null,
      sponsorId: null,
      userId: userId,
      balance: balance,
      vacanciesAdminParams: {
        sort: '-created_at',
        page: 1,
        'per-page': 4,
        sponsor_ids: partnerId
      },
      loaded: false
    }
  },

  computed: {
    showMoreBtn() {
      if (
        this.vacanciesListAdmin &&
        this.vacanciesListAdmin.length &&
        this.vacanciesMeta.currentPage < this.vacanciesMeta.pageCount
      ) {
        return true
      }
      return false
    }
  },
  async created() {
    await this.getVacanciesList(this.vacanciesAdminParams)
  },
  methods: {
    formatSalary,

    async getVacanciesList(params) {
      try {
        this.loading = true
        const { data, meta } = await useVacancies().getVacanciesList(params)
        this.vacanciesListAdmin = data
        this.vacanciesMeta = meta
        this.loaded = true
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },

    async deleteVacancy(id) {
      try {
        this.vacanciesAdminParams.page = 1
        const { deleteVacancy } = await useVacancies()
        await deleteVacancy(id)
        await this.getVacanciesList(this.vacanciesAdminParams)
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },

    async addMoreVacancies() {
      const { data, meta } = await useVacancies().getVacanciesList(this.vacanciesAdminParams)
      this.vacanciesListAdmin = [...this.vacanciesListAdmin, ...data ]
      this.vacanciesMeta = meta
    },

    async showMore() {
      this.vacanciesAdminParams.page++
      await this.addMoreVacancies()
    },
  }
})
